<template>
  <v-card elevation="4" class="dashboard-card rounded-xl pa-4 fill-height capital-card capital-summary-card">
    <div class="dashboard-section-title mb-4">Resumen de mi cuenta capital</div>
    <div class="capital-summary-grid mb-4">
      <div class="capital-summary-box capital-box-primary">
        <span>Saldo total de capital</span>
        <strong>{{ formatMonto(capitalResumen.saldoTotal) }}</strong>
      </div>
      <div class="capital-summary-box capital-box-success">
        <span>Disponible para solicitud  de giro</span>
        <strong>{{ formatMonto(capitalResumen.disponibleRetiro) }}</strong>
      </div>
    </div>
    <div class="capital-detail-list">
      <div v-for="item in capitalResumen.detalle" :key="item.label">
        <span>{{ item.label }}</span>
        <strong>{{ item.value }}</strong>
      </div>
    </div>
  </v-card>
</template>

<script>
import conv from "@/services/conversores";

export default {
  name: "CapitalSummaryCard",
  props: {
    capitalResumen: {
      type: Object,
      default: () => ({ saldoTotal: 0, disponibleRetiro: 0, detalle: [] })
    }
  },
  methods: {
    formatMonto(value) {
      return conv.formatMonto(value || 0, true);
    }
  }
};
</script>

<style scoped>
.dashboard-card {
  width: 100%;
  background: #ffffff !important;
  border: 1px solid rgba(31, 45, 53, 0.08);
  box-shadow: 0 10px 28px rgba(20, 52, 57, 0.1) !important;
}

.dashboard-section-title {
  color: #20333a;
  font-size: 1.05rem;
  font-weight: 700;
}

.capital-summary-card {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.capital-summary-grid {
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr;
}

.capital-summary-box {
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  min-height: auto;
  padding: 11px 12px;
}

.capital-box-primary {
  background: linear-gradient(135deg, #f2f6ff 0%, #ffffff 100%);
}

.capital-box-success {
  background: linear-gradient(135deg, #eef9ef 0%, #ffffff 100%);
}

.capital-summary-box span,
.capital-detail-list span {
  color: #5f7278;
  font-size: 0.78rem;
}

.capital-summary-box strong {
  color: #20333a;
  font-size: 1.2rem;
  line-height: 1.3;
}

.capital-box-success strong {
  color: #138a37;
}

.capital-detail-list div {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
}

.capital-detail-list strong {
  color: #20333a;
  font-size: 0.86rem;
  font-weight: 700;
}
</style>
